import {comparators, objOmit, objToArrK} from "../tools/CommonJS";
import {doesSearchIncTpc, severitiesDefsArr, severitiesDefs} from "./CommonUIData";
import BenchmarkTypes from "compliance-types/ComplianceTypes.json";
export const Benchmark_topics = BenchmarkTypes.benchmark_orgs;
export const Benchmark_rules = Benchmark_topics.cis.rules;
export const Benchmark_controls = BenchmarkTypes.controls["8.0"];
export const Benchmark_cisProfiles = BenchmarkTypes.benchmark_orgs.cis.profiles, Benchmark_cisProfilesArr = objToArrK(Benchmark_cisProfiles);

export const c_framework = "8.0"

// remove from description any html elements not P / SPAN / STRONG / LI / UL
export const replaceDescForbiddenTags = (descStr) => descStr?.replace(/<(?!\/?(p|span|strong|li|ul)\b)[^>]*>(.*?)<\/(?!\/?(p|span|strong|li|ul)\b)[^>]*>/ig, "");

export function xBenchmark_Repo(rowData) {
    const currRepo = Benchmark_rules[rowData.topicCode];
    
    return currRepo ? {...currRepo, severity: (rowData.severity || "Unknown"), description: replaceDescForbiddenTags(currRepo?.description)} : {
        frameworks: {},
        title: "Unknown: " + rowData.topicCode + ". Please upgrade the software to the latest version.",
        severity: rowData.severity || "Unknown",
        profiles: [],
        description: "",
    };
}

export const getBenchmarkOpts = (level, filter)  => [{h: "All", k: "All"} ,...Object.entries(Benchmark_topics.cis[filter])?.map(([key, val]) => ({k: key, h: val}))];


export const  cisLevelDefs = {
    "Level 1": {h: "CIS - Level 1", shortH: "L1", comb: "*Level_1*"},
    "Level 2": {h: "CIS - Level 2", shortH: "L2", comb: "*Level_2*"},
    "STIG": {h: "STIG", shortH: "STIG", comb: "*STIG*"}
}, cisLevelOpts = objToArrK(cisLevelDefs);

export const getControlDefs = (controlKey) => controlKey.includes(":") ? {...Benchmark_controls[controlKey.split(":")[0]].controls[controlKey],
    parent: Benchmark_controls[controlKey.split(":")[0]] } : Benchmark_controls[controlKey];

export const getControlsFromRules = (topics, inp) => {
    const {filteredData} = filterSortComp(topics, objOmit(inp, ["control"]));
    const availableControls = filteredData.map(rule => xBenchmark_Repo(rule).frameworks[c_framework]).filter(Boolean).flat().undup();

    return [{h: "All", k: "All", n: filteredData.length}, ...objToArrK(Benchmark_controls).map(c => ({
        k: c.k, h: c.title, n: filteredData.filter(rule => xBenchmark_Repo(rule).frameworks[c_framework]?.some(f => f.startsWith(`${c.k}:`))).length,
        subMenu: objToArrK(c.controls).filter(control => availableControls.includes(control.k)).map(control => ({k: control.k, h: control.title}))
    }))].filter(c => c.n);
}

const values = ["repeated", "remediated", "alertsOk", "alertsBad", "alertsNew", "devicesOk", "devicesBad", "devicesUnmeasured"];

const aggregateIfNeeded = (tpc, obj) => {
    if (!obj[tpc.topicCode]) return {}
    return Object.fromEntries(values.map(key => [key, (obj[tpc.topicCode]?.[key] || 0) + tpc[key]]));
}

export const filterSortComp = (topics, {level, control, search, os, severities, sortBy}) => {
    const removeTpcWithSameLevel = {};
    topics?.forEach(tpc => {
        if (Benchmark_cisProfilesArr.find(({title, id}) => id === tpc.profile)?.level === level &&
            (!os || (os ==="All" || tpc.os?.includes(os))))
            removeTpcWithSameLevel[tpc.topicCode] = {...tpc, ...aggregateIfNeeded(tpc, removeTpcWithSameLevel),
                profile: [
                    ...(removeTpcWithSameLevel[tpc.topicCode]?.profile || []),
                    (!removeTpcWithSameLevel[tpc.topicCode]?.includes?.(tpc.profile) && tpc.profile)
                ].undup()};
    });

    let severityVals = [{k: severitiesDefs.passed.idx, v: 0}, {k: severitiesDefs.unknown.idx, v: 0}];

    const filteredData = Object.values(removeTpcWithSameLevel).filter(tpc => {
        const repo = xBenchmark_Repo(tpc);

        tpc.devicesBad === 0 ? (severityVals[0] ?? {}).v++ : (severityVals[1] ?? {}).v++;

        return (!search || doesSearchIncTpc(repo, search)) &&
            (!severities?.length || severities.some(sevIdx =>
                severitiesDefsArr.find(({idx}) => idx === sevIdx)?.k === "passed" ? (tpc.devicesBad === 0) : tpc.devicesBad)) &&
            (!control || (control === "All" || repo.frameworks[c_framework]?.some(f => f.startsWith(control))));
    }).sort(compSortDefs[sortBy]?.sort);

    return {filteredData, severityVals}
};

const getCompTopicSeverityIdx = tpc => tpc.devicesBad ? 0 : 1;

export const compSortDefs = {
    title: {h: "Alert Name", sort: (a,b) => comparators.stringSig(a.title, b.title)},
    severity: {h: "Severity", sort: (a,b) => getCompTopicSeverityIdx(a) - getCompTopicSeverityIdx(b)},
    alertsBad: {h: "Total Alerts", sort: (a,b) => b.devicesBad - a.devicesBad},
}, compSortOpts = objToArrK(compSortDefs);